import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo, useEffect, useState, useCallback } from 'react';
import classnames from 'classnames';
import { createUseStyles, Button, Text, Icon, Menus, Checkbox, Loader, useTheme } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
import { saveDashboardFilters } from "../../../../lib/services/forceBI";
import ModalConfirm from "../../../../components/ModalConfirm";
import ModalSaveBeforeLeave from "./ModalSaveBeforeLeave";
import { successToast, errorToast } from "../../../../utils/toast";
import copyToClipboard from "../../../../utils/copy";
import { CHARTS_LIST, FORCE_BI_SUBMODULE } from "../../constants";
import styles from "./styles";
import useBlockNavigation from "../../../../hooks/useBlockNavigation";
const useStyles = createUseStyles(styles, 'Header');
var _ref6 = /*#__PURE__*/React.createElement(Loader, {
  size: "tiny"
});
var _ref7 = /*#__PURE__*/React.createElement(Loader, {
  size: "tiny"
});
var _ref8 = /*#__PURE__*/React.createElement(Loader, {
  size: "tiny"
});
const Header = /*#__PURE__*/memo(_ref => {
  var _forceBIFiltersProps$, _forceBIFiltersProps$2;
  let {
    dashboardId,
    onOpenCreate,
    filtersComponent,
    entity,
    filtersAddButtonSchema,
    onSelectAll,
    widgets,
    selected,
    onClearSelected,
    onDeleteMultiple,
    onOpenShare,
    onOpenBulkShare,
    onDownloadImages,
    onDownloadTables,
    canUseEmail,
    canShare,
    canCreate,
    canDelete,
    canSaveFilters,
    forceBIFiltersProps,
    forceBIUtils,
    hasWidgets,
    areFiltersSaved,
    setAreFiltersSaved,
    areFiltersChanged,
    isLoading,
    customDashboardFilters,
    hashHistory,
    ensureRoute
  } = _ref;
  const theme = useTheme();
  const classes = useStyles();
  const {
    t,
    entities,
    getWeb4EntityFromString,
    logEvent
  } = useWeb5Context();
  const [innerSelected, setInnerSelected] = useState(selected || []);
  const [isBulkDeleteOpen, setIsBulkDeleteOpen] = useState(false);
  const [isLoadingEmailBulk, setIsLoadingEmailBulk] = useState(false);
  const [isLoadingImages, setIsLoadingImages] = useState(false);
  const [isLoadingTables, setIsLoadingTables] = useState(false);
  const [isLoadingSaveFilters, setIsLoadingSaveFilters] = useState(false);
  useEffect(() => {
    let timer;
    if (!selected.length) {
      timer = setTimeout(() => {
        setInnerSelected([]);
      }, 300);
    } else {
      setInnerSelected(selected);
    }
    return () => timer && clearTimeout(timer);
  }, [selected]);
  const Filters = filtersComponent;
  const topFiltersProps = useMemo(() => _objectSpread({
    className: classes.filters,
    useQuickFilters: true,
    entity,
    defaultFilters: [],
    defaultQuickFilters: [],
    ignoreDefaultCrossFilters: true,
    filtersAddButtonSchema,
    showQuickFiltersAdd: true,
    forceSelectAllTypes: true,
    useAddIcon: true,
    entityToForceLabel: entities.COMPANIES
  }, forceBIFiltersProps), [entity, filtersAddButtonSchema, forceBIFiltersProps, classes === null || classes === void 0 ? void 0 : classes.filters, entities]);
  const onBulkDeleteOpen = useCallback(() => setIsBulkDeleteOpen(true), []);
  const onCancelBulkDelete = useCallback(() => setIsBulkDeleteOpen(false), []);
  const handleOnDeleteMultiple = useCallback(() => {
    onDeleteMultiple().then(() => {
      setIsBulkDeleteOpen(false);
    });
  }, [onDeleteMultiple]);
  const modalConfirmProps = useMemo(() => {
    return {
      onConfirm: handleOnDeleteMultiple,
      onCancel: onCancelBulkDelete,
      isOpen: isBulkDeleteOpen,
      title: t('title_delete_selected_widgets'),
      advice: t('label_delete_widgets_alert'),
      writeXToConfirm: 'label_type_confirmation',
      passPhrase: t('action_delete'),
      confirmText: t('action_delete'),
      isConfirmLoading: false,
      forceSelectAllTypes: true
    };
  }, [isBulkDeleteOpen, handleOnDeleteMultiple, onCancelBulkDelete, t]);
  const isIndeterminate = useMemo(() => {
    if (selected.length > 0 && selected.length < widgets.length) return true;
    return false;
  }, [selected, widgets]);
  const isChecked = useMemo(() => {
    if (selected.length > 0 && selected.length === widgets.length || isIndeterminate) return true;
    return false;
  }, [selected, widgets, isIndeterminate]);
  const labelSelected = useMemo(() => {
    if ((innerSelected === null || innerSelected === void 0 ? void 0 : innerSelected.length) === 1) return t('label_num_widgets_selected_singular');
    return t('label_num_widgets_selected');
  }, [innerSelected, t]);
  const isSaveFiltersDisabled = useMemo(() => {
    var _customCache$visibleF;
    const {
      customCache,
      filters,
      crossFilters,
      operators,
      crossOperators
    } = topFiltersProps;
    if (!(customCache !== null && customCache !== void 0 && (_customCache$visibleF = customCache.visibleFilters) !== null && _customCache$visibleF !== void 0 && _customCache$visibleF.length) && !areFiltersChanged) return true;
    const numberCrossFilters = Object.entries(crossFilters).reduce((num, _ref2) => {
      let [entity, filters] = _ref2;
      if (Object.keys(filters).length) num++;
      return num;
    }, 0);
    const numberCrossOperators = Object.entries(crossOperators).reduce((num, _ref3) => {
      let [entity, operators] = _ref3;
      if (Object.keys(operators).length) num++;
      return num;
    }, 0);
    if (areFiltersSaved) return true;
    if (areFiltersChanged) return false;
    if (!Object.keys(filters).length && !Object.keys(operators).length && !numberCrossFilters && !numberCrossOperators) return true;
    return false;
  }, [topFiltersProps, areFiltersSaved, areFiltersChanged]);
  const onSaveFilters = useCallback(() => {
    if (!canSaveFilters || isSaveFiltersDisabled) return Promise.resolve();
    setIsLoadingSaveFilters(true);
    const {
      filters,
      crossFilters,
      operators,
      crossOperators,
      customCache
    } = topFiltersProps;
    const {
      translateFiltersForBackend
    } = forceBIUtils;
    const {
      filters: newFilters,
      operators: newOperators
    } = translateFiltersForBackend({
      filters,
      crossFilters,
      operators,
      crossOperators
    });
    return saveDashboardFilters(dashboardId, {
      filters: newFilters,
      operators: newOperators,
      visibleFilters: customCache.visibleFilters
    }).then(() => {
      setAreFiltersSaved(true);
      successToast({
        t,
        text: t('label_save_filters_success')
      });
    }).catch(() => {
      errorToast({
        t,
        text: t('label_save_filters_error')
      });
    }).finally(() => {
      setIsLoadingSaveFilters(false);
    });
  }, [canSaveFilters, topFiltersProps, forceBIUtils, dashboardId, t, isSaveFiltersDisabled, setAreFiltersSaved]);
  const shouldBlockNavigation = useMemo(() => {
    return canSaveFilters && !isSaveFiltersDisabled;
  }, [canSaveFilters, isSaveFiltersDisabled]);
  const {
    isBlockModalOpen,
    onConfirmAndUnblock,
    onCancelAndUnblock
  } = useBlockNavigation({
    hashHistory,
    ensureRoute,
    shouldBlockNavigation,
    confirmPromise: onSaveFilters
  });
  const isBulkLoading = useMemo(() => {
    return isLoadingEmailBulk || isLoadingImages || isLoadingTables;
  }, [isLoadingEmailBulk, isLoadingImages, isLoadingTables]);
  const isLoadingImagesOrTables = useMemo(() => {
    return isLoadingImages || isLoadingTables;
  }, [isLoadingImages, isLoadingTables]);
  const handleDownloadImages = useCallback(() => {
    if (isBulkLoading) return;
    setIsLoadingImages(true);
    onDownloadImages().finally(() => {
      setIsLoadingImages(false);
    });
  }, [isBulkLoading, onDownloadImages]);
  const handleDownloadTables = useCallback(() => {
    if (isBulkLoading) return;
    setIsLoadingTables(true);
    onDownloadTables().finally(() => {
      setIsLoadingTables(false);
    });
  }, [isBulkLoading, onDownloadTables]);
  const downloadOptions = useMemo(() => {
    const options = [];
    const imagesToDownload = widgets.reduce((arr, current) => {
      if (selected.includes(parseInt(current.id, 10)) && CHARTS_LIST.includes(current.chartType)) arr.push(parseInt(current.id, 10));
      return arr;
    }, []);
    if (imagesToDownload.length) {
      options.push({
        title: /*#__PURE__*/React.createElement(Text, {
          type: "body",
          color: theme.colors.utility.textPrimary
        }, t('label_download_as_image')),
        icon: /*#__PURE__*/React.createElement(Icon, {
          name: "image",
          color: theme.colors.actionMinor[500]
        }),
        onClick: handleDownloadImages
      });
    }
    options.push({
      title: /*#__PURE__*/React.createElement(Text, {
        type: "body",
        color: theme.colors.utility.textPrimary
      }, t('label_download_as_excel')),
      icon: /*#__PURE__*/React.createElement(Icon, {
        className: classes.excelIcon,
        name: "xls",
        color: theme.colors.actionMinor[500]
      }),
      onClick: handleDownloadTables
    });
    return options;
  }, [handleDownloadImages, handleDownloadTables, theme.colors, classes.excelIcon, t, selected, widgets]);
  const shareOptions = useMemo(() => {
    return [{
      title: /*#__PURE__*/React.createElement(Text, {
        type: "body",
        color: theme.colors.utility.textPrimary
      }, t('action_copy')),
      icon: /*#__PURE__*/React.createElement(Icon, {
        name: "contentLink",
        color: theme.colors.actionMinor[500]
      }),
      onClick: () => {
        copyToClipboard(window.location.href, t);
        logEvent({
          event: entities.ANALYTICS_REPORT.trueName,
          functionality: 'share',
          submodule: FORCE_BI_SUBMODULE
        });
      }
    }, {
      title: /*#__PURE__*/React.createElement(Text, {
        type: "body",
        color: theme.colors.utility.textPrimary
      }, t('label_share_dashboard')),
      icon: /*#__PURE__*/React.createElement(Icon, {
        name: "email",
        color: theme.colors.actionMinor[500]
      }),
      onClick: onOpenShare
    }];
  }, [onOpenShare, t, theme.colors, logEvent, entities]);
  const labelSelectUnselect = useMemo(() => {
    if (selected.length) return t('label_clear_selection');
    return t('label_selectall');
  }, [selected, t]);
  const handleOnOpenBulkShare = useCallback(() => {
    setIsLoadingEmailBulk(true);
    onOpenBulkShare().finally(() => {
      setIsLoadingEmailBulk(false);
    });
  }, [onOpenBulkShare]);
  const hasCustomDashboardFilters = useMemo(() => customDashboardFilters && Object.keys(customDashboardFilters).length, [customDashboardFilters]);
  const renderCustomFilters = useMemo(() => {
    if (!customDashboardFilters || !Object.keys(customDashboardFilters).length) return null;
    return Object.entries(customDashboardFilters).reduce((arr, _ref4) => {
      let [entity, filters] = _ref4;
      if (!filters || !Object.entries(filters)) return arr;
      Object.entries(filters).forEach(_ref5 => {
        let [id, filter] = _ref5;
        const newEntity = getWeb4EntityFromString(entity);
        arr.push(/*#__PURE__*/React.createElement("div", {
          key: id,
          className: classes.customFiltersContainer
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.customFilter
        }, /*#__PURE__*/React.createElement(Text, {
          color: theme.colors.semantic.info500
        }, `${filter.completeValues.label} (${t(newEntity.labels.plural)})`))));
      });
      return arr;
    }, []);
  }, [customDashboardFilters, classes.customFilter, classes.customFiltersContainer, getWeb4EntityFromString, t, theme]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, widgets.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.left
  }, (widgets === null || widgets === void 0 ? void 0 : widgets.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.selectAll
  }, /*#__PURE__*/React.createElement(Checkbox, {
    color: "actionMajor",
    onChange: onSelectAll,
    checked: isChecked,
    indeterminate: isIndeterminate
  }), /*#__PURE__*/React.createElement(Text, null, labelSelectUnselect)), (selected === null || selected === void 0 ? void 0 : selected.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.bulkActions
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.separator
  }), /*#__PURE__*/React.createElement(Text, null, `${innerSelected.length} ${labelSelected}`), /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, canDelete && onDeleteMultiple && /*#__PURE__*/React.createElement(Icon, {
    name: "delete",
    onClick: onBulkDeleteOpen,
    tooltip: t('label_delete_selected')
  }), !isLoadingImagesOrTables && /*#__PURE__*/React.createElement(Menus, {
    className: classes.downloadMenu,
    classNameMenu: classes.downloadMenuPopover,
    title: /*#__PURE__*/React.createElement(Icon, {
      name: "fileDownload",
      tooltip: t('label_download_selected')
    }),
    items: downloadOptions,
    size: "large",
    triggerAction: "hover"
  }), isLoadingImagesOrTables && _ref6, canShare && !isLoadingEmailBulk && /*#__PURE__*/React.createElement(Icon, {
    name: "email",
    onClick: handleOnOpenBulkShare,
    tooltip: t('label_share_selected')
  }), canShare && isLoadingEmailBulk && _ref7))), (selected === null || selected === void 0 ? void 0 : selected.length) === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.center
  }, widgets.length > 0 && ((forceBIFiltersProps === null || forceBIFiltersProps === void 0 ? void 0 : (_forceBIFiltersProps$ = forceBIFiltersProps.customCache) === null || _forceBIFiltersProps$ === void 0 ? void 0 : (_forceBIFiltersProps$2 = _forceBIFiltersProps$.visibleFilters) === null || _forceBIFiltersProps$2 === void 0 ? void 0 : _forceBIFiltersProps$2.length) > 0 || hasCustomDashboardFilters) && !isLoading && /*#__PURE__*/React.createElement("div", {
    className: classes.dividerFilters
  }), !isLoading && renderCustomFilters, hasWidgets && /*#__PURE__*/React.createElement(Filters, topFiltersProps)), /*#__PURE__*/React.createElement("div", {
    className: classes.right
  }, hasWidgets && canSaveFilters && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.saveButton, {
      [classes.saveButtonDisabled]: isSaveFiltersDisabled,
      [classes.saveButtonLoading]: isLoadingSaveFilters
    })
  }, isLoadingSaveFilters && _ref8, !isLoadingSaveFilters && /*#__PURE__*/React.createElement(Icon, {
    name: "save",
    size: "large",
    tooltip: t('action_save_filters'),
    onClick: !isSaveFiltersDisabled ? onSaveFilters : null
  })), (widgets === null || widgets === void 0 ? void 0 : widgets.length) > 0 && (canShare || canCreate) && /*#__PURE__*/React.createElement("div", {
    className: classes.dividerActions
  }), hasWidgets && canUseEmail && canShare && /*#__PURE__*/React.createElement(Menus, {
    className: classes.shareMenu,
    classNameMenu: classes.shareMenuPopover,
    title: /*#__PURE__*/React.createElement(Button, {
      type: "terciary",
      icon: "share"
    }, t('action_share')),
    items: shareOptions,
    size: "medium"
  }), canCreate && /*#__PURE__*/React.createElement(Button, {
    onClick: onOpenCreate,
    isDisabled: isLoading
  }, t('label_forcebi_crud_title_placeholder')))), /*#__PURE__*/React.createElement(ModalConfirm, modalConfirmProps), /*#__PURE__*/React.createElement(ModalSaveBeforeLeave, {
    isOpen: isBlockModalOpen,
    onCancel: onCancelAndUnblock,
    onConfirm: onConfirmAndUnblock
  }));
});
export default Header;